export const pedestrianRoutesForFamiliesData = {
  title: "Pěší - rodiny s dětmi",
  introduction:
    "Trasy jsou pouze doporučené a účastníci si je mohou dle potřeb upravit. Každý se účastní na vlastní riziko.",
  downloadMapsComment: "Všechny trasy ke stažení.",
  downloadMapLink: "Odkaz na mapy.cz",
  mapsPath: "https://mapy.cz/s/ladovasete",
  routeDetails: [
    {
      subtitle: "Trasa A - 9 km",
      routeDescription: "kolem jezera",
      path: "https://mapy.cz/s/jegugusako",
      src: "/images/routes/trasa-A.png",
    },
  ],
};
